import { workerEntities } from '../constants';

export const getWorker = ({ request, workerKey, workerObj }) => {
  const worker = request[workerKey] || workerObj;

  return {
    ...worker,
    title: workerEntities[workerKey].title,
    text: workerEntities[workerKey].text,
    change:
      typeof workerEntities[workerKey].fn === 'function'
        ? (dispatch) => {
            const {
              houseId,
              addressId,
              serviceId,
              garantyId,
              id: requestId,
            } = request;

            const param = {
              houseId,
              addressId,
              serviceId,
              possWarranty: garantyId > 0,
              requestId,
            };

            workerEntities[workerKey].fn({ dispatch, param, worker });
          }
        : undefined,
  };
};

export const canChangeWorker = ({
  request,
  worker,
  workerObj,
  userInfo,
  considerPaidId,
}) => {
  if (considerPaidId && request.paidServiceRequestId) {
    return false;
  }

  return workerObj
    ? typeof worker.change === 'function'
    : userInfo.CanChangeExecutors;
};
